import React from 'react';
import { Icon } from 'tea-component';
import { getTextWithHighlight } from '../../utils';
import GameIcon from '../GameIcon';
import { IGame } from '../../interfaces';
import { useIntl } from 'umi';
import './index.scss';

const Game: React.FC<IGame> = (props) => {
  const {
    id,
    entityType,
    entityName,
    cover,
    releaseTime,
    publisher,
    keyword,
    showClose = false,
    onClose,
  } = props;

  const { formatMessage } = useIntl();

  const renderGameNameWithHighlight = (name: string): React.ReactNode => {
    if (typeof name !== 'string') return '-';
    return getTextWithHighlight(name, keyword);
  };

  const handleClose = () => {
    if (!(onClose instanceof Function)) return;
    onClose(id);
  };

  return (
    <div className="dbi-benchmark-selector-item dbi-firstRow-flex">
      <GameIcon entityType={entityType} src={cover} />
      <div className="dbi-benchmark-selector-item-detail dbi-firstRow-gametitle">
        <div className="dbi-firstRow-title">
          {renderGameNameWithHighlight(entityName)}
        </div>
        <div className="dbi-firstRow-right">
          <span className="dbi-firstRow-text">
           {formatMessage({id: 'dbi_benchmark_release'})} {releaseTime || '-'}
          </span>
          <span className="dbi-firstRow-box">
            <span className="dbi-firstRow-text-tip"> {publisher || '-'}</span>
          </span>
        </div>
      </div>
      {showClose && (
        <div className="dbi-benchmark-selector-close">
          <Icon type="dismiss" onClick={handleClose} />
        </div>
      )}
    </div>
  );
};

export default Game;
